import type { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth.guard';
import { tipoGuard } from './core/guards/tipo.guard';
import { cambioPasswordGuard, segundoFactorGuard } from './core/guards/seguridad.guard';
import { ACCESO_ROUTES } from './features/acceso/acceso.routes';

// Una aplicación, tres áreas (SPEC §28.1). Cada área carga su layout y sus rutas en diferido.
export const routes: Routes = [
  {
    path: 'vendedor',
    canActivate: [authGuard, tipoGuard('VENDEDOR')],
    canActivateChild: [cambioPasswordGuard, tipoGuard('VENDEDOR')],
    loadComponent: () =>
      import('./shared/layout/layout-vendedor/layout-vendedor.component').then((m) => m.LayoutVendedorComponent),
    loadChildren: () => import('./features/vendedor/vendedor.routes').then((m) => m.VENDEDOR_ROUTES),
  },
  {
    path: 'admin',
    canActivate: [authGuard, tipoGuard('INTERNO')],
    canActivateChild: [cambioPasswordGuard, segundoFactorGuard],
    loadComponent: () =>
      import('./shared/layout/layout-admin/layout-admin.component').then((m) => m.LayoutAdminComponent),
    loadChildren: () => import('./features/admin/admin.routes').then((m) => m.ADMIN_ROUTES),
  },
  // El QR de una etiqueta (RN-LOG-10) solo lleva el token; se abre en el panel interno
  { path: 'q/:token', redirectTo: ({ params }) => `/admin/bolsas/${params['token']}` },
  ...ACCESO_ROUTES,
  {
    path: '',
    loadComponent: () =>
      import('./shared/layout/layout-publico/layout-publico.component').then((m) => m.LayoutPublicoComponent),
    loadChildren: () => import('./features/publico/publico.routes').then((m) => m.PUBLICO_ROUTES),
  },
  { path: '**', redirectTo: '' },
];
